export default {
  wallet: 'Wallet',
  deposit: 'Desposit',
  withdraw: 'Withdraw',
  withdrawalBalance: 'Withdrawal balance',
  yourWalletBalance: 'Your wallet balance',
  pleaseWriteTheAmountYouWantToWithdraw:
    'Please write the amount you want to withdraw',
  pleaseSelectTheDestinationBank: 'Please select the destination bank',
  bankAccount: 'Bank account',
  pleaseSelectWithdrawType: 'Please select withdraw type',
  fast: 'Fast',
  normal: 'Normal',
  wage: 'Wage',
  autoCharge: 'Auto Charge',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  autoChargeDaily: 'Automatic charging will be done daily',
  autoChargeWeeklyOn_day_: 'Automatic charging will be done weekly on {day}',
  autoChargeMonthlyOn_day_: 'Automatic charging will be done monthly on {day}',
  day: 'day'
}
